import MessagesStub from '../components/MessagesStub';

export default MessagesStub;



// WEBPACK FOOTER //
// ./src/containers/Messages.js